export default __webpack_public_path__ + "media/images/features/yado/ogp-761be55ce40fcb19a6a9926a50156739.jpg";